// @core/api/endpoints/document/delete_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete document
 * Permanently deletes a standalone document and all its versions. Requires admin privileges.
 */
export async function DeleteDocument(
  document_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
